import React from 'react';
import PropTypes from 'prop-types';

import colors from 'themes/Main';
import * as S from './styles';

const { darkBlue } = colors;

const Label = ({ color, size, text, htmlFor, pd, hasMargin }) => (
  <>
    <S.Label
      htmlFor={htmlFor}
      fontColor={color}
      hasMargin={hasMargin}
      fontSize={size}
      pd={pd}
    >
      {text}
    </S.Label>
  </>
);

export default Label;

Label.defaultProps = {
  color: darkBlue,
  size: 14,
  pd: 0,
  hasMargin: false,
};

Label.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  text: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  pd: PropTypes.number,
  hasMargin: PropTypes.bool,
};
